import {useState, useEffect, ReactNode} from "react";
import Modal from "./Modal";
import {UseCaseSlideProps} from "../types/types";
import ModalCardContent from "./ModalCardContent";
import OmniChannelContactCentre from "./battleCards/OmniChannelContactCentre";
import ContactCentreRemediation from "./battleCards/ContactCentreRemediation";
import AIFirstContactCentre from "./battleCards/AIFirstContactCentre";
import AIFirstContactCentreModernisation from "./battleCards/AIFirstContactCentreModernisation";
import AIPoweredSelfServiceAutomation from "./battleCards/AIPoweredSelfServiceAutomation​";
import CustomAIML from "./battleCards/CustomAIML";

const CardSliderSectionBlk = ({cards}: UseCaseSlideProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCardIndex, setSelectedCardIndex] = useState<number | null>(
    null
  );

  const handleOpenModal = (index: number) => {
    setSelectedCardIndex(index);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedCardIndex(null);
    setIsModalOpen(false);
  };

  const selectedCard =
    selectedCardIndex !== null ? cards[selectedCardIndex] : null;

  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);

  const cardComponents: Record<string, ReactNode> = {
    "Omnichannel Contact Centre Transformation": <OmniChannelContactCentre />,
    "Contact Centre Remediation & Uplift": <ContactCentreRemediation />,
    "AI-First Contact Centre Modernisation": (
      <AIFirstContactCentreModernisation />
    ),
    "AI-Powered Self-Service & Automation": <AIPoweredSelfServiceAutomation />,
    "Custom AI/ML & Reporting - Advanced Analytics for Contact Centres": (
      <CustomAIML />
    ),
  };

  return (
    <section className="card-slider-section">
      <div className="main-container-blk">
        <div className="card-slider-container">
          {cards.map((card, index) => (
            <ModalCardContent
              key={index}
              card={card}
              index={index}
              onClick={handleOpenModal}
            />
          ))}
        </div>
      </div>

      {/* Reusable Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        titleModal={selectedCard?.title || ""}>
        {selectedCard && cardComponents[selectedCard.title]}
      </Modal>
    </section>
  );
};

export default CardSliderSectionBlk;
